(function ($, document, window) {
    var contentPuffCheckBoxListScroll = {

        init: function (baseElement) {
            var currentPage = 1;
            var numberOfPages = 1;
            var $el = $(baseElement);
            var $next = $el.find('.Form__Element__Nav__Right');
            var $prev = $el.find('.Form__Element__Nav__Left');

            var itemsContainer = $el.find('.Form__Element__Items');
            var firstChild = itemsContainer.children().first();
            var offset = 0;

            function setTransform(newXValue) {
                var updatedTranslateXCssValue = 'translateX(' + newXValue + 'px)';

                itemsContainer[0].style.transform = updatedTranslateXCssValue;
                itemsContainer[0].style.webkitTransform = updatedTranslateXCssValue;
            }

            function getTranslateX(nextpage) {
                var clientWidth = itemsContainer[0].clientWidth;
               
                var fullItems = Math.floor(clientWidth / offset);                
                var gotoIndex = (nextpage - 1) * fullItems;
                return offset * gotoIndex * -1;
            }

            function getOffset() {
                return firstChild.outerWidth() + parseInt(firstChild.css('margin-right'));
            }

            $next.on('click', function (event) {
                numberOfPages = Math.ceil(itemsContainer[0].scrollWidth / itemsContainer[0].clientWidth);
                offset = getOffset();
                
                if (currentPage + 1 <= numberOfPages) {
                    var newXValue = getTranslateX(currentPage + 1);                    
                    setTransform(newXValue);
                    currentPage = currentPage + 1;
                }
            });

            $prev.on('click', function (event) {
                numberOfPages = Math.ceil(itemsContainer[0].scrollWidth / itemsContainer[0].clientWidth);
                offset = getOffset();
                if (currentPage - 1 > 0) {
                    var newXValue = getTranslateX(currentPage - 1);
                    if (currentPage - 1 === 1) {
                        newXValue = 0;
                    }
                    setTransform(newXValue);                    
                    currentPage = currentPage - 1;
                }
            });
        },
        getCurrentTranslateXValue: function (element) {
            var style = window.getComputedStyle(element);
            var matrix = style.transform || style.webkitTransform || style.mozTransform;

            if (matrix === 'none' || typeof matrix === 'undefined') {
                return 0;
            }

            var matrixType = matrix.includes('3d') ? '3d' : '2d';
            var matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');

            if (matrixType === '2d') {
                return matrixValues[4];
            }

            if (matrixType === '3d') {
                return matrixValues[12];
            }

        },
        getContainer: function (element) {
            return $(element).parent().siblings(".Form__Element__Items")[0];
        },

    };
    $(".PuffFormCheckboxList").each(function (idx, item) {
        contentPuffCheckBoxListScroll.init(item);
    })

})(jQuery, document, window);